import { connect } from 'react-redux';
import Details from './Details';

function mapStateToProps(state) {
    const clientConfigEmpty = Object.keys(state.app.clientConfig).length === 0;
    const appConfigEmpty = Object.keys(state.app.appConfig).length === 0;
    const loading = clientConfigEmpty || appConfigEmpty || state.app.redirect;

    return {
        user: state.member,
        clientConfig: state.app.clientConfig,
        presentationConfig: state.app.presentationConfig,
        routes: state.routes,
        loading,
    };
}

const DetailsContainer = connect(mapStateToProps)(Details);

export default DetailsContainer;
